// extracted by mini-css-extract-plugin
export default {"container":"s1-z"};